import http from '@/http'

const PATH = '/contracts'

export default {
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listContracts (params) {
        try {
            const response = await http.get(PATH, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{contractId: number}} data
     * @returns {Promise<void>}
     */
    async showContract ({contractId}) {
        try {
            const response = await http.get(`${PATH}/${contractId}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
